// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"2e6ab77a","496":"5cd20eca"}[chunkId] + ".chunk.js";
};